"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// index-browser.ts
var index_browser_exports = {};
__export(index_browser_exports, {
  RELEASE_NOTES_ROLE_FILTER: () => RELEASE_NOTES_ROLE_FILTER,
  eventTypes: () => eventTypes,
  fraudInvestigationStatuses: () => fraudInvestigationStatuses,
  isFraudInvestigationStatus: () => isFraudInvestigationStatus,
  kachParticipantSyncReasons: () => kachParticipantSyncReasons,
  releaseNoteCompanyFlags: () => releaseNoteCompanyFlags,
  releaseNoteComparisonTones: () => releaseNoteComparisonTones,
  releaseNoteDemos: () => releaseNoteDemos,
  releaseNoteEventTypes: () => releaseNoteEventTypes,
  releaseNoteItemKinds: () => releaseNoteItemKinds,
  releaseNoteKinds: () => releaseNoteKinds,
  releaseNoteListFilters: () => releaseNoteListFilters,
  releaseNoteMetricDirections: () => releaseNoteMetricDirections,
  releaseNoteMetricKinds: () => releaseNoteMetricKinds,
  releaseNoteMetricUnits: () => releaseNoteMetricUnits,
  releaseNoteSectionKinds: () => releaseNoteSectionKinds,
  releaseNoteStatuses: () => releaseNoteStatuses,
  releaseNoteViewSources: () => releaseNoteViewSources,
  teamDelegationNoticeKinds: () => teamDelegationNoticeKinds
});
module.exports = __toCommonJS(index_browser_exports);
__reExport(index_browser_exports, require("@prisma/client/index-browser.js"), module.exports);

// constants/event-types.ts
var eventTypes = [
  "complaint_form_step_view",
  "sinister_complaints_view",
  "rfp_bid_winner_selected",
  "rfp_bid_submitted",
  "rfp_created",
  "rfp_canceled",
  "contract_created",
  "contract_report_created",
  "contract_report_accepted",
  "contract_report_rejected",
  "contract_updates_published",
  "contract_updates_requested",
  "contract_invoice_uploaded",
  "appraisal_invoice_uploaded",
  "appraisal_updates_published",
  "appraisal_updates_requested",
  "appraisal_report_rejected",
  "appraisal_report_accepted",
  "appraisal_report_created",
  "field_adjuster_assigned",
  "offer_expired",
  "offer_rejected",
  "offer_accepted",
  "fraud_updated",
  "fraud_closed",
  "fraud_investigation_report_accepted",
  "fraud_news_answered",
  "fraud_news_requested",
  "fraud_claim_result_updated",
  "complaint_file_request_uploaded",
  "file_request_uploaded",
  "file_view",
  "role_detail_view",
  "sinister_created",
  "roles_view",
  "invitations_view",
  "settings_notifications_view",
  "settings_team_view",
  "settings_distribution_view",
  "settings_profile_view",
  "sinister_claim_detail_view",
  "sinister_third_party_complaints_view",
  "sinister_fraud_investigation_cases_view",
  "sinister_claims_view",
  "sinister_expert_appraisals_view",
  "forwarded_invitation",
  "complaint_created",
  "sinister_complaint_chat_message_send",
  "sinister_claim_chat_message_send",
  "sinister_claim_chat_view",
  "documentation_filter",
  "documentation_search",
  "claim_document_view",
  "external_complaint_documentation_list_view",
  "complaint_documentation_list_view",
  "sinister_documentation_list_view",
  "claim_documentation_list_view",
  "fraud_activity_view",
  "claim_activity_view",
  "complaint_activity_view",
  "sinister_claim_view",
  "sinister_table_view",
  "claim_form_step_view",
  "claim_form_step_completed",
  "sinister_view",
  "sinister_search",
  "sinister_filter",
  "sinister_list_view",
  "target_group_updated",
  "users_invited",
  "load_balance_rule_detail_view",
  "target_group_detail_view",
  "target_groups_view",
  "load_balance_rules_view",
  "load_balance_rule_updated",
  "load_balance_rule_deleted",
  "load_balance_rule_created",
  "target_group_deleted",
  "target_group_created",
  "complaint_collaborator_unassigned",
  "claim_collaborator_unassigned",
  "complaint_collaborator_assigned",
  "claim_collaborator_assigned",
  "claim_responsible_unassigned",
  "claim_responsible_assigned",
  "claim_created",
  "claim_status_updated",
  "complaint_status_updated",
  "complaint_responsible_assigned",
  "file_requested",
  "file_request_placeholder_cancelled",
  "upload_files",
  "pending_sinister_complaint",
  "pending_file_request_upload",
  "login",
  "logout",
  "claim_documentation_requested",
  "criminal_case_request",
  "claim_not_response",
  "claim_offer_flow",
  "claim_documentation_completed",
  "claim_rejected",
  "claim_additional_management",
  "claim_ownership_transfer_requested",
  "claim_ownership_transfer_accepted",
  "claim_ownership_transfer_rejected",
  "claim_ownership_assigned",
  "claim_estimates_updated",
  "pending_offer_response",
  "pending_offer_agreement_response",
  "offer_agreement_completed",
  "offer_agreement_rejected",
  "offer_agreement_expired",
  "offer_agreement_cancelled",
  "pending_offer_response_internal",
  "pending_offer_agreement_response_internal",
  "claim_updated",
  "complaint_sinister_cause_updated",
  "external_complaint_selected",
  "claim_sinister_changed",
  "claim_derived",
  "claim_responsibility_returned",
  "claim_derived_returned",
  "claim_derivation_canceled",
  "claim_derivation_restore_status_updated",
  "pending_complaint_created",
  "rfp_expired",
  "external_complaint_created",
  "complaint_authorized",
  "external_complaint_authorized",
  "complaint_approved",
  "external_complaint_approved",
  "complaint_rejected",
  "external_complaint_rejected",
  "complaint_estimates_updated",
  "order_created",
  "order_report_created",
  "order_report_accepted",
  "order_report_rejected",
  "order_updates_published",
  "order_updates_requested",
  "order_invoice_uploaded",
  "alert_sla_objective_progress",
  "alert_sla_total_progress",
  "sinister_external_status_updated",
  "complaint_updated",
  "complaint_confirmation_signature",
  "claim_file_uploaded",
  "offer_created",
  "offer_agreement_created",
  "offer_canceled",
  "claim_confirmation_signature",
  "team_updated",
  "team_detail_view",
  "teams_view",
  "team_deleted",
  "team_created",
  "tags_view",
  "tag_created",
  "tag_updated",
  "tag_deleted",
  "claim_comment_created",
  "claim_created_documents_missing",
  "claim_file_request_completed",
  "pending_complaint_requested",
  "pending_complaint_creation_failed",
  "external_complaint_selection_failed",
  "fraud_investigation_case_created",
  "fraud_reopened",
  "claim_status_communication_sent",
  "order_accepted",
  "order_rejected",
  "order_canceled",
  "order_report_reset",
  "order_invoice_accepted",
  "order_invoice_rejected",
  "order_invoice_reset",
  "order_completed",
  "order_reopened",
  "order_document_uploaded",
  "order_work_proof_created",
  "order_work_proof_approved",
  "order_work_proof_disapproved",
  "order_work_proof_blocked",
  "claim_mediation_started",
  "claim_lawsuit_started",
  "order_scheduled",
  "order_rescheduled",
  "order_schedule_canceled",
  "order_required_document_uploaded",
  "order_required_document_accepted",
  "order_required_document_rejected",
  "order_required_document_reset",
  "order_document_removed",
  "claim_reconciled",
  "claim_form_vehicle_id_card_extracted",
  "offer_agreement_dispatch_failed",
  "offer_agreement_recipient_submitted",
  "user_assignments_paused",
  "user_assignments_resumed",
  "team_claims_reassigned",
  "user_inactivity_started",
  "user_inactivity_ended",
  "user_inactivity_scheduled",
  "user_inactivity_rescheduled",
  "user_inactivity_return_changed",
  "user_inactivity_cancelled",
  "team_claims_delegated",
  "user_inactivity_claims_delegated",
  "user_inactivity_delegation_updated",
  "user_inactivity_delegation_discarded",
  "team_claims_recovered",
  "user_delegated_claims_recovered",
  "user_delegated_claims_returned",
  "user_derived_claims_returned",
  "user_derived_claims_recovered"
];

// constants/team-delegation-notice-kinds.ts
var teamDelegationNoticeKinds = [
  "delegation_review",
  "uncovered_claims"
];

// constants/fraud-investigation-statuses.ts
var fraudInvestigationStatuses = [
  "not_assigned",
  "in_progress",
  "derived_to_lab",
  "in_extension",
  "without_result",
  "closed"
];
var isFraudInvestigationStatus = (value) => fraudInvestigationStatuses.includes(value);

// constants/kach-participant-sync-reasons.ts
var kachParticipantSyncReasons = [
  "handler_committed",
  "responsibility_returned",
  "substitute_assigned",
  "derivation_closed_externally",
  "team_reassigned",
  "team_delegated",
  "team_delegated_claims_moved",
  "responsible_reassigned",
  "responsibility_derived",
  "delegation_restored",
  "collaborator_removed",
  "claim_moved",
  "case_derived",
  "claim_added_to_case",
  "case_reopened",
  "sinister_handler_changed",
  "claim_status_changed",
  "sinister_status_changed",
  "periodic_reconcile",
  "backfill"
];

// constants/release-notes.ts
var releaseNoteKinds = ["feature", "improvement", "fix"];
var releaseNoteStatuses = ["draft", "published"];
var releaseNoteCompanyFlags = [
  "claim_evaluation",
  "claim_rfp",
  "orders",
  "providers",
  "performance_metrics",
  "recovery_claim",
  "team_management"
];
var releaseNoteListFilters = ["all", "unread", "mine"];
var RELEASE_NOTES_ROLE_FILTER = "role";
var releaseNoteItemKinds = ["overview", "feature"];
var releaseNoteSectionKinds = [
  "text",
  "heading",
  "bullets",
  "steps",
  "comparison",
  "cards",
  "callout",
  "decision",
  "demo",
  "image"
];
var releaseNoteDemos = ["team_members_table"];
var releaseNoteComparisonTones = ["accent", "neutral"];
var releaseNoteEventTypes = [
  "release_notes_list_view",
  "release_notes_list_filter",
  "release_notes_list_search",
  // The sidebar's quick look at the latest note, before opening it.
  "release_note_peek",
  "release_note_view",
  "release_note_item_view",
  "release_note_toc_click",
  "release_note_demo_interaction",
  "release_note_link_click",
  "release_note_feedback",
  // Sent when the reader leaves, with how long and how far they read.
  "release_note_read",
  // Recorded by the backoffice for each user it emails about a note.
  "release_note_notified"
];
var releaseNoteViewSources = [
  "list",
  "direct",
  "sidebar",
  "email"
];
var releaseNoteMetricDirections = ["up", "down", "flat"];
var releaseNoteMetricUnits = [
  "count",
  "users",
  "percent",
  "minutes",
  "hours",
  "days"
];
var releaseNoteMetricKinds = [
  "event_count",
  "event_users",
  "event_users_ratio",
  "event_interval",
  "pending"
];
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  RELEASE_NOTES_ROLE_FILTER,
  eventTypes,
  fraudInvestigationStatuses,
  isFraudInvestigationStatus,
  kachParticipantSyncReasons,
  releaseNoteCompanyFlags,
  releaseNoteComparisonTones,
  releaseNoteDemos,
  releaseNoteEventTypes,
  releaseNoteItemKinds,
  releaseNoteKinds,
  releaseNoteListFilters,
  releaseNoteMetricDirections,
  releaseNoteMetricKinds,
  releaseNoteMetricUnits,
  releaseNoteSectionKinds,
  releaseNoteStatuses,
  releaseNoteViewSources,
  teamDelegationNoticeKinds,
  ...require("@prisma/client/index-browser.js")
});
